import axiosInstance from "../modules/axiosInstance";

export const NewsApi = {
  list: async () => {
    const r = await axiosInstance.get("api/news");
    return r.data;
  },

  create: async (payload) => {
    const r = await axiosInstance.post("api/news", payload);
    return r.data;
  },

  update: async (id, payload) => {
    const r = await axiosInstance.put(`api/news/${id}`, payload);
    return r.data;
  },

  remove: async (id) => {
    await axiosInstance.delete(`api/news/${id}`);
  },

  reorder: async (ids) => {
    await axiosInstance.post("api/news/reorder", { order: ids });
  },

  // 👇 Nuevo método para alternar "hidden"
  toggleHidden: async (id, hidden) => {
    const r = await axiosInstance.put(`api/news/${id}`, { hidden });
    return r.data;
  },
};
